// extracted by mini-css-extract-plugin
export default {"duplicate_guide":"Style_duplicate_guide__kyAVw","duplicate":"Style_duplicate__6a6Ed","no_duplicate":"Style_no_duplicate__ivZ8q"};